import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import apiFetch from "../../../../shared/services/apiClient";
import { FiltrosBarra } from "./BalanceComprobacion";
import invoiceStyles from "../../invoices/styles/invoice.module.css";

const BASE = process.env.REACT_APP_API_URL ?? "";

async function descargarPDF(url, filename, setLoading, setError) {
  setLoading(true);
  setError("");
  try {
    const token = localStorage.getItem("access_token");
    const rol   = localStorage.getItem("rol");
    const extraHeaders = rol === "CONTADOR"
      ? { "X-Condominio-ID": localStorage.getItem("active_condominio_id") || "" }
      : {};
    const res = await window.fetch(`${BASE}${url}`, {
      headers: { Authorization: `Bearer ${token}`, ...extraHeaders },
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.detail || `Error ${res.status}`);
    }
    const blob = await res.blob();
    const href = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch (e) {
    setError(e.message);
  } finally {
    setLoading(false);
  }
}

// ── Modal de firma ────────────────────────────────────────────────────────────
function ToggleGroup({ value, options, onChange }) {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {options.map(({ key, label }) => {
        const active = value === key;
        return (
          <button key={key} onClick={() => onChange(key)}
            style={{ padding: "5px 14px", borderRadius: 6,
              border: `1px solid ${active ? "#f97316" : "var(--border-card)"}`,
              background: active ? "rgba(249,115,22,0.12)" : "transparent",
              color: active ? "#f97316" : "var(--text-muted)",
              fontWeight: active ? 700 : 400, fontSize: "0.84rem", cursor: "pointer",
              transition: "all 0.15s" }}>
            {label}
          </button>
        );
      })}
    </div>
  );
}

function FirmaModal({ onConfirm, onCancel }) {
  const { t } = useTranslation();
  const [incluirFirma, setIncluirFirma] = useState(true);
  const [campoFirma,   setCampoFirma]   = useState("");
  const [moneda,       setMoneda]       = useState("CRC");
  const [idioma,       setIdioma]       = useState("es");

  const MONEDAS = [
    { key: "CRC", icon: "₡", label: "Colones",  borderRight: true },
    { key: "USD", icon: "$", label: "Dólares",   borderRight: false },
  ];
  const IDIOMAS = [
    { key: "es", flag: "🇨🇷", label: "Español", borderRight: true },
    { key: "en", flag: "🇺🇸", label: "English",  borderRight: false },
  ];

  return (
    <>
      {/* Overlay */}
      <div onClick={onCancel} style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.72)",
        backdropFilter: "blur(5px)", zIndex: 1000,
      }}/>

      {/* Modal */}
      <div onClick={e => e.stopPropagation()} style={{
        position: "fixed", top: "50%", left: "50%",
        transform: "translate(-50%,-50%)",
        background: "var(--bg-card)", border: "1px solid var(--border-card)",
        borderRadius: 16, width: "min(500px,95vw)",
        zIndex: 1001, boxShadow: "0 32px 80px rgba(0,0,0,0.65)",
        overflow: "hidden",
      }}>

        {/* ── Header ── */}
        <div style={{
          background: "linear-gradient(135deg,rgba(249,115,22,0.13) 0%,rgba(249,115,22,0.04) 100%)",
          borderBottom: "1px solid var(--border-card)",
          padding: "18px 22px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
            <div style={{
              width: 44, height: 44, borderRadius: 11, flexShrink: 0,
              background: "rgba(249,115,22,0.14)", border: "1px solid rgba(249,115,22,0.28)",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <i className="fa-solid fa-file-pdf" style={{ color: "#f97316", fontSize: "1.15rem" }}/>
            </div>
            <div>
              <div style={{ fontSize: "1rem", fontWeight: 700, color: "var(--text-primary)", lineHeight: 1.2 }}>
                {t("reportes.opcionesPDF")}
              </div>
              <div style={{ fontSize: "0.74rem", color: "var(--text-muted)", marginTop: 2 }}>
                {t("reportes.configuraPDF")}
              </div>
            </div>
          </div>
          <button onClick={onCancel} style={{
            background: "none", border: "none", cursor: "pointer",
            color: "var(--text-muted)", fontSize: "1.1rem", padding: "4px 6px",
            borderRadius: 6, lineHeight: 1,
          }}
            onMouseOver={e => e.currentTarget.style.color = "var(--text-primary)"}
            onMouseOut={e  => e.currentTarget.style.color = "var(--text-muted)"}>
            ✕
          </button>
        </div>

        {/* ── Body ── */}
        <div style={{ padding: "22px 24px", display: "flex", flexDirection: "column", gap: 18 }}>

          {/* Moneda */}
          <div>
            <div style={{ fontSize: "0.67rem", fontWeight: 700, letterSpacing: "1.1px",
              textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.monedaReporte")}
            </div>
            <div style={{ display: "flex", borderRadius: 9,
              border: "1px solid var(--border-card)", overflow: "hidden" }}>
              {MONEDAS.map(opt => {
                const active = moneda === opt.key;
                return (
                  <button key={opt.key} onClick={() => setMoneda(opt.key)} style={{
                    flex: 1, padding: "10px 0", border: "none",
                    borderRight: opt.borderRight ? "1px solid var(--border-card)" : "none",
                    background: active ? "rgba(249,115,22,0.14)" : "transparent",
                    color: active ? "#f97316" : "var(--text-muted)",
                    fontWeight: active ? 700 : 400, fontSize: "0.88rem",
                    cursor: "pointer", transition: "all 0.15s",
                  }}>
                    <span style={{ marginRight: 5 }}>{opt.icon}</span>{opt.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Idioma */}
          <div>
            <div style={{ fontSize: "0.67rem", fontWeight: 700, letterSpacing: "1.1px",
              textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.idiomaReporte")}
            </div>
            <div style={{ display: "flex", borderRadius: 9,
              border: "1px solid var(--border-card)", overflow: "hidden" }}>
              {IDIOMAS.map(opt => {
                const active = idioma === opt.key;
                return (
                  <button key={opt.key} onClick={() => setIdioma(opt.key)} style={{
                    flex: 1, padding: "10px 0", border: "none",
                    borderRight: opt.borderRight ? "1px solid var(--border-card)" : "none",
                    background: active ? "rgba(99,102,241,0.13)" : "transparent",
                    color: active ? "#818cf8" : "var(--text-muted)",
                    fontWeight: active ? 700 : 400, fontSize: "0.88rem",
                    cursor: "pointer", transition: "all 0.15s",
                  }}>
                    <span style={{ marginRight: 6 }}>{opt.flag}</span>{opt.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Divider */}
          <div style={{ borderTop: "1px solid var(--border-card)", margin: "0 -2px" }}/>

          {/* Incluir firma */}
          <label style={{
            display: "flex", alignItems: "center", gap: 13, cursor: "pointer",
            background: "var(--hover-bg)", borderRadius: 9, padding: "12px 14px",
            border: `1px solid ${incluirFirma ? "rgba(249,115,22,0.3)" : "var(--border-card)"}`,
            transition: "border-color 0.15s",
          }}>
            <input type="checkbox" checked={incluirFirma}
              onChange={e => setIncluirFirma(e.target.checked)}
              style={{ accentColor: "#f97316", width: 16, height: 16, flexShrink: 0 }}/>
            <div>
              <div style={{ color: "var(--text-primary)", fontSize: "0.87rem", fontWeight: 600 }}>
                {t("reportes.incluirFirma")}
              </div>
              <div style={{ color: "var(--text-muted)", fontSize: "0.74rem", marginTop: 2 }}>
                {t("reportes.firmaDesc")}
              </div>
            </div>
          </label>

          {/* Segundo firmante */}
          <div>
            <label style={{ fontSize: "0.67rem", fontWeight: 700, letterSpacing: "1.1px",
              textTransform: "uppercase", color: "var(--text-muted)", display: "block", marginBottom: 7 }}>
              {t("reportes.segundoFirmante")}
            </label>
            <input type="text" value={campoFirma}
              onChange={e => setCampoFirma(e.target.value)}
              placeholder={t("reportes.segundoFirmantePlaceholder")}
              style={{ width: "100%", background: "var(--bg-input)",
                border: "1px solid var(--border-input)", borderRadius: 8,
                color: "var(--text-primary)", padding: "9px 13px", fontSize: "0.85rem",
                boxSizing: "border-box", outline: "none", transition: "border-color 0.15s" }}
              onFocus={e => e.target.style.borderColor = "#f97316"}
              onBlur={e  => e.target.style.borderColor = "var(--border-input)"}/>
          </div>
        </div>

        {/* ── Footer ── */}
        <div style={{
          borderTop: "1px solid var(--border-card)",
          background: "var(--hover-bg)",
          padding: "14px 24px",
          display: "flex", justifyContent: "flex-end", gap: 10,
        }}>
          <button onClick={onCancel} style={{
            padding: "9px 18px", background: "transparent",
            border: "1px solid var(--border-card)", borderRadius: 8,
            color: "var(--text-muted)", fontSize: "0.85rem", cursor: "pointer",
          }}
            onMouseOver={e => { e.currentTarget.style.borderColor = "var(--text-secondary)"; e.currentTarget.style.color = "var(--text-secondary)"; }}
            onMouseOut={e  => { e.currentTarget.style.borderColor = "var(--border-card)";     e.currentTarget.style.color = "var(--text-muted)"; }}>
            {t("common.cancelar")}
          </button>
          <button onClick={() => onConfirm({ incluirFirma, campoFirma, moneda, idioma })} style={{
            padding: "9px 22px", background: "#f97316", border: "none", borderRadius: 8,
            color: "#fff", fontWeight: 700, fontSize: "0.85rem", cursor: "pointer",
            display: "flex", alignItems: "center", gap: 8,
            boxShadow: "0 4px 16px rgba(249,115,22,0.38)",
          }}
            onMouseOver={e => e.currentTarget.style.background = "#ea6b0c"}
            onMouseOut={e  => e.currentTarget.style.background = "#f97316"}>
            <i className="fa-solid fa-file-pdf"/>
            {t("reportes.generarPDFBtn")}
          </button>
        </div>
      </div>
    </>
  );
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function finDeMes(desde) {
  if (!desde) return "";
  const [y, m] = desde.split("-").map(Number);
  const ultimo = new Date(y, m, 0);
  return ultimo.toISOString().split("T")[0];
}

// ── Componente principal ──────────────────────────────────────────────────────
export default function EstadoFinanciero() {
  const { t, i18n } = useTranslation();

  const fmtLindo = (iso) => {
    if (!iso) return "—";
    const date = new Date(iso + "T00:00:00");
    const locale = i18n.resolvedLanguage === "en" ? "en-US" : "es-CR";
    return date.toLocaleDateString(locale, { day: "numeric", month: "long", year: "numeric" });
  };

  const SECCIONES = [
    { icon: "fa-chart-bar",        n: "01", labelKey: "reportes.sec01Label", descKey: "reportes.sec01Desc", color: "#f97316" },
    { icon: "fa-scale-balanced",   n: "02", labelKey: "reportes.sec02Label", descKey: "reportes.sec02Desc", color: "#60a5fa" },
    { icon: "fa-note-sticky",      n: "03", labelKey: "reportes.sec03Label", descKey: "reportes.sec03Desc", color: "#a78bfa" },
    { icon: "fa-users",            n: "04", labelKey: "reportes.sec04Label", descKey: "reportes.sec04Desc", color: "#4ade80" },
    { icon: "fa-building",         n: "05", labelKey: "reportes.sec05Label", descKey: "reportes.sec05Desc", color: "#fb923c" },
    { icon: "fa-building-columns", n: "06", labelKey: "reportes.sec06Label", descKey: "reportes.sec06Desc", color: "#34d399" },
  ];

  const now       = new Date();
  const mesInicio = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,"0")}-01`;
  const mesFin    = finDeMes(mesInicio);

  const [fechaDesde, setFechaDesde] = useState(mesInicio);
  const [fechaHasta, setFechaHasta] = useState(mesFin);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState("");
  const [showModal,  setShowModal]  = useState(false);

  function handleDesdeChange(val) {
    setFechaDesde(val);
    setFechaHasta(finDeMes(val));
  }

  function buildQS(opts = {}) {
    const qs = new URLSearchParams();
    if (fechaDesde) qs.set("fecha_desde", fechaDesde);
    if (fechaHasta) qs.set("fecha_hasta", fechaHasta);
    qs.set("incluir_firma", opts.incluirFirma ? "true" : "false");
    if (opts.campoFirma) qs.set("campo_firma", opts.campoFirma);
    if (opts.moneda) qs.set("moneda", opts.moneda);
    if (opts.idioma) qs.set("idioma", opts.idioma);
    return qs.toString();
  }

  function handleGenerar() { setShowModal(true); }

  function handleConfirm(opts) {
    setShowModal(false);
    const url = `/api/finance/reportes/estado-financiero/?${buildQS(opts)}`;
    const fn  = `estados_financieros_${fechaHasta.replace(/-/g,"")}.pdf`;
    descargarPDF(url, fn, setLoading, setError);
  }

  return (
    <>
      <span className={invoiceStyles.inactive}>
        <Link to="/">
          <span className={invoiceStyles.inactive}>{t("common.inicio")} /</span>
        </Link>
        <span className={invoiceStyles.active}> {t("reportes.estadoFinanciero")}</span>
      </span>
      <div>
        <h2 className="title mt-2 mb-2">{t("reportes.estadoFinanciero")}</h2>
        <p className="mb-3" style={{ color: "var(--text-muted)" }}>{t("reportes.estadoFinancieroDesc")}</p>
      </div>

      {/* ── Panel selector de fechas ── */}
      <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-card)",
        borderRadius: 12, padding: "22px 24px", marginBottom: 24 }}>

        {error && (
          <div style={{ background: "rgba(248,113,113,0.08)",
            border: "1px solid rgba(248,113,113,0.25)", borderLeft: "3px solid #f87171",
            borderRadius: 8, padding: "10px 14px", marginBottom: 18,
            color: "#fca5a5", fontSize: "0.83rem",
            display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fa-solid fa-circle-exclamation"/>
            {error}
          </div>
        )}

        <div style={{ display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)", gap: 16, alignItems: "flex-end" }}>

          {/* DESDE */}
          <div>
            <label style={{ display: "block", fontSize: "0.68rem", fontWeight: 700,
              letterSpacing: "1px", textTransform: "uppercase",
              color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.desde")}
            </label>
            <div style={{ background: "var(--bg-input)", border: "1px solid var(--border-input)",
              borderRadius: 8, padding: "10px 14px",
              display: "flex", alignItems: "center", gap: 10 }}>
              <i className="fa-regular fa-calendar"
                 style={{ color: "#f97316", fontSize: "0.88rem", flexShrink: 0 }}/>
              <input type="date" value={fechaDesde}
                onChange={e => handleDesdeChange(e.target.value)}
                style={{ background: "transparent", border: "none", outline: "none",
                  color: "var(--text-primary)", fontSize: "0.88rem", fontWeight: 600,
                  colorScheme: "light dark", cursor: "pointer", flex: 1, width: "100%" }}/>
            </div>
            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginTop: 4, paddingLeft: 2 }}>
              {fmtLindo(fechaDesde)}
            </div>
          </div>

          {/* HASTA — solo lectura, se calcula automático */}
          <div>
            <label style={{ display: "block", fontSize: "0.68rem", fontWeight: 700,
              letterSpacing: "1px", textTransform: "uppercase",
              color: "var(--text-muted)", marginBottom: 8 }}>
              {t("reportes.hasta")}
              <span style={{ marginLeft: 6, fontWeight: 400, color: "var(--text-muted)",
                fontSize: "0.62rem", textTransform: "none", letterSpacing: 0 }}>
                {t("reportes.finMesAutomatico")}
              </span>
            </label>
            <div style={{ background: "var(--bg-input)", border: "1px solid var(--border-input)",
              borderRadius: 8, padding: "10px 14px",
              display: "flex", alignItems: "center", gap: 10,
              opacity: 0.7 }}>
              <i className="fa-regular fa-calendar-check"
                 style={{ color: "#4ade80", fontSize: "0.88rem", flexShrink: 0 }}/>
              <span style={{ color: "var(--text-primary)", fontSize: "0.88rem",
                fontWeight: 600, fontFamily: "monospace" }}>
                {fechaHasta}
              </span>
            </div>
            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginTop: 4, paddingLeft: 2 }}>
              {fmtLindo(fechaHasta)}
            </div>
          </div>
        </div>

        {/* Resumen período */}
        {fechaDesde && fechaHasta && (
          <div style={{ marginTop: 16, paddingTop: 14,
            borderTop: "1px solid var(--border-card)",
            display: "flex", alignItems: "center", gap: 8 }}>
            <i className="fa-solid fa-circle-info"
               style={{ color: "var(--text-muted)", fontSize: "0.78rem" }}/>
            <span style={{ fontSize: "0.78rem", color: "var(--text-muted)" }}>
              {t("reportes.periodo")}{" "}
              <strong style={{ color: "var(--text-secondary)" }}>
                {fmtLindo(fechaDesde)} — {fmtLindo(fechaHasta)}
              </strong>
            </span>
          </div>
        )}
      </div>

      {/* ── Secciones del PDF ── */}
      <div style={{ marginBottom: 8 }}>
        <p style={{ margin: "0 0 16px", fontSize: "0.7rem", fontWeight: 700,
          letterSpacing: "2px", textTransform: "uppercase",
          color: "var(--text-muted)", textAlign: "center" }}>
          {t("reportes.contenidoPDF")}
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
          {SECCIONES.map(({ icon, n, labelKey, descKey, color }) => (
            <div key={n}
              style={{ background: "var(--bg-card)", border: "1px solid var(--border-card)",
                borderRadius: 12, padding: "18px 20px",
                display: "flex", alignItems: "center", gap: 14,
                position: "relative", overflow: "hidden",
                transition: "border-color 0.15s, transform 0.1s" }}
              onMouseOver={e => {
                e.currentTarget.style.borderColor = color + "55";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={e => {
                e.currentTarget.style.borderColor = "var(--border-card)";
                e.currentTarget.style.transform = "translateY(0)";
              }}>

              {/* Número decorativo de fondo */}
              <span style={{ position: "absolute", right: 12, top: "50%",
                transform: "translateY(-50%)", fontSize: "3.8rem", fontWeight: 900,
                fontFamily: "'Montserrat',sans-serif", color: color + "12",
                lineHeight: 1, userSelect: "none", letterSpacing: "-2px",
                pointerEvents: "none" }}>
                {n}
              </span>

              {/* Ícono */}
              <div style={{ width: 42, height: 42, borderRadius: 10, flexShrink: 0,
                background: color + "14", border: `1px solid ${color}28`,
                display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className={`fa-solid ${icon}`} style={{ color, fontSize: "1rem" }}/>
              </div>

              {/* Texto */}
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: "0.87rem", fontWeight: 700,
                  color: "var(--text-primary)", lineHeight: 1.3, marginBottom: 3 }}>
                  {t(labelKey)}
                </div>
                <div style={{ fontSize: "0.74rem", color: "var(--text-muted)" }}>{t(descKey)}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Botón principal ── */}
      <div style={{ marginTop: 24, display: "flex", justifyContent: "center" }}>
        <button onClick={handleGenerar} disabled={loading}
          style={{ background: "#f97316", border: "none", borderRadius: 10,
            padding: "13px 40px", color: "#fff", fontWeight: 700, fontSize: "1rem",
            cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1,
            display: "flex", alignItems: "center", gap: 10,
            boxShadow: "0 8px 28px rgba(249,115,22,0.32)",
            transition: "all 0.15s" }}
          onMouseOver={e => { if (!loading) { e.currentTarget.style.background = "#ea6b10"; e.currentTarget.style.transform = "translateY(-1px)"; }}}
          onMouseOut={e  => { if (!loading) { e.currentTarget.style.background = "#f97316";  e.currentTarget.style.transform = "translateY(0)"; }}}>
          {loading
            ? <><i className="fa-solid fa-circle-notch fa-spin"/> {t("reportes.generandoPDF")}</>
            : <><i className="fa-solid fa-file-pdf" style={{ fontSize: "1.1rem" }}/> {t("reportes.generarPDF")}</>}
        </button>
      </div>

      <p style={{ textAlign: "center", marginTop: 12,
        fontSize: "0.74rem", color: "var(--text-muted)" }}>
        {t("reportes.descargaAuto")}
      </p>

      {/* ── Modal de firma ── */}
      {showModal && (
        <FirmaModal onConfirm={handleConfirm} onCancel={() => setShowModal(false)}/>
      )}
    </>
  );
}

// ── Hook reutilizable ─────────────────────────────────────────────────────────
export function usePDFIndividual(endpoint, filename) {
  const [loading,     setLoading]     = useState(false);
  const [error,       setError]       = useState("");
  const [showModal,   setShowModal]   = useState(false);
  const [pendingOpts, setPendingOpts] = useState(null);

  function generar(extraQS = "") {
    setShowModal(true);
    setPendingOpts(extraQS);
  }

  function confirmar(opts) {
    setShowModal(false);
    const qs = new URLSearchParams(pendingOpts || "");
    qs.set("incluir_firma", opts.incluirFirma ? "true" : "false");
    if (opts.campoFirma) qs.set("campo_firma", opts.campoFirma);
    if (opts.moneda) qs.set("moneda", opts.moneda);
    if (opts.idioma) qs.set("idioma", opts.idioma);
    descargarPDF(`${endpoint}?${qs}`, filename, setLoading, setError);
  }

  const modal = showModal
    ? <FirmaModal onConfirm={confirmar} onCancel={() => setShowModal(false)}/>
    : null;

  return { loading, error, generar, modal };
}
